import React from "react";
import {connect} from "react-redux";
import {Button, Col} from "reactstrap";
import {Trans, useTranslation} from "react-i18next";
import qs from "qs";


const FacebookPermissionsRequired = (
    {
        activeShop,
        user,
    }
) => {
    const {t, i18n} = useTranslation();

    // Attention! This redirect URL is used in service_core python code! DO NOT CHANGE!
    const state = `${activeShop.id}-${user.id}`
    const redirectUri = qs.stringify({redirect_uri: `https://${window.location.hostname}/service/service_core/facebook/oauth_login`});
    const oauthUrl = `https://www.facebook.com/v8.0/dialog/oauth?client_id=${process.env.REACT_APP_FB_APP_ID}&${redirectUri}&state=${state}&auth_type=rerequest&scope=pages_show_list,pages_messaging,pages_manage_metadata`;

    return <div className="d-flex justify-content-center align-items-center">
        <Col md="8" className="mx-auto app-login-box">
            <div className="modal-dialog w-100 mx-auto">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="app-header__logo w-100 justify-content-center">
                            <div className="logo-src"/>
                        </div>

                        <div className='modal-body font-size-md mt-4'>
                            <h1 className="text-center">
                                ⚠️
                            </h1>
                            <h5 className='text-center mb-3'>
                                {t('connect_bot.facebook_permissions_required.title', 'Please, allow following permissions to connect Page:')}
                            </h5>

                            <ol>
                                <Trans t={t} i18nKey='connect_bot.facebook_permissions_required.instruction'>
                                    <li className='mb-3'>
                                        Доступ к перепискам от имени Страницы в Messenger и управление ими - для
                                        отправки сообщений от имени страницы
                                    </li>
                                    <li className='mb-3'>
                                        Показать список Страниц, которыми вы управляете - для подключения бота к
                                        странице
                                    </li>
                                    <li className='mb-3'>
                                        Управлять аккаунтами, настройками и Webhooks для Страницы - для приёма сообщений
                                        отправленных странице
                                    </li>
                                </Trans>
                            </ol>

                            <div className='text-center px-4 pt-4 text-primary'>
                                <Trans t={t} i18nKey='connect_bot.facebook_permissions_required.instruction_2'>
                                    К сожалению, не все необходимые разрешения были предоставлены.
                                    Пожалуйста, выберите хотя бы одну страницу и предоставьте все необходимые
                                    разрешения
                                </Trans>
                            </div>
                        </div>

                        <div className="p-4 text-center">
                            <a href={oauthUrl}>
                                <Button color='primary btn-large' className='mt-2'
                                        onClick={() => window.location.reload()}>
                                    {t('connect_bot.common.try_again', 'Try again')}
                                </Button>
                            </a>
                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <a href="#" className="btn-lg btn btn-link">
                            {t('connect_bot.common.back_to_bot_list', 'Back to bots list')}
                        </a>
                    </div>
                </div>
            </div>
        </Col>
    </div>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    user: state.Auth.user,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FacebookPermissionsRequired);
